import { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { basket_id_selector } from "../ducks/basket/selectors";
import { clear_basket_action } from "../ducks/basket/actions";
import { showMessage } from "react-native-flash-message";
import { ID } from "../types/server";
import useOrdersNeedsActionList from "../ducks/user/hooks/useOrdersNeedsActionList";
import { requestHelper } from "../helpers/request-helper";
import { formatAndRaiseError } from "../helpers/general";
import useNavigation from "./useNavigation";
import { Platform } from "react-native";

export default useSaveBasket;

type SaveTypes = "collection" | "delivery";

interface SetLogistic {
  address_id: number;
  period_id: number;
  order_id: number;
  type: SaveTypes;
}

function saveOrder({ address_id, period_id, order_id, type }: SetLogistic) {
  let type_uppercase = type.toUpperCase();
  return requestHelper(
    `
        mutation saveOrder(
          $type: LegacyOrderTypesEnums!
          $addressId: Int!
          $periodId: Int!
          $orderId: Int!
        ) {
          proxyCustomerSaveOrder(
            type: $type
            addressId: $addressId
            periodId: $periodId
            orderId: $orderId
          ) {
            suceess
          }
        }
      `,
    {
      type: type_uppercase,
      addressId: address_id,
      periodId: period_id,
      orderId: order_id,
    }
  )
    .then((data) => {
      return data.proxyCustomerSaveOrder;
    })
    .catch(formatAndRaiseError);
}

//

interface SaveArguments {
  address_id: ID;
  period_id: ID;
  meta?: {
    address: string;
    time: string;
  };
}

interface Options {
  order_id?: number | string;
}

function useSaveBasket(type: SaveTypes = "collection", options?: Options) {
  let [loading, setLoading] = useState(false);
  let order_id = useSelector(basket_id_selector);
  if (options && options.order_id) {
    order_id = options.order_id;
  }
  let dispatch = useDispatch();
  let nav = useNavigation();
  let { revalidate } = useOrdersNeedsActionList();

  let save = useCallback(
    async function save({ address_id, period_id, meta }: SaveArguments) {
      setLoading(true);
      if (type === "collection") {
        // [TODO]: if there are some `queue`, sync them first then clear basket
        try {
          let collectionResponse = await saveOrder({
            address_id,
            period_id,
            order_id,
            type,
          });
          dispatch(clear_basket_action());

          revalidate();
          nav.jumpAndNavigate({
            jumpTo: "Orders",
            navigateTo: "OrderView",
            navigateParams: {
              order_id: order_id,
            },
          });

          showMessage({
            type: "success",
            message: "سفارش شما با موفقیت ثبت شد.",
            description:
              "همکاران ما برای جمع آوری لباس در موعد مقرر حضور خواهند یافت.",
            duration: 5000,
          });
          return collectionResponse;
        } catch (e) {
          showMessage({
            type: "danger",
            message: e,
          });
        } finally {
          setLoading(false);
        }
      } else if (type === "delivery") {
        try {
          let deliveryResponse = await saveOrder({
            address_id,
            period_id,
            order_id,
            type,
          });

          showMessage({
            type: "success",
            message: "زمان تحویل با موفقیت ثبت شد.",
            description:
              "همکاران ما برای تحویل لباس در موعد مقرر حضور خواهند یافت.",
          });

          revalidate();

          return deliveryResponse;
        } catch (e) {
          showMessage({
            type: "danger",
            message: e,
          });
        } finally {
          setLoading(false);
        }
      }
    },
    [order_id]
  );

  return {
    save,
    loading,
  };
}
